import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import ProjectService from '../../services/ProjectService'

export const useProjectContent = () => {
  const { org, project } = useParams()
  return useQuery<any>({
    queryKey: ['project-content', org, project],
    queryFn: () => ProjectService.getProjectContents(org!, project!),
    enabled: !!org && !!project,
  })
}
